import { AppRootStateType } from 'state/store';

export const usersSelect = (state: AppRootStateType) => state.users.users;
export const choosedUserSelect = (state: AppRootStateType) => state.users.user;
export const userLoadingSelect = (state: AppRootStateType) => state.users.isLoading;
export const patientVisitsSelect = (state: AppRootStateType) => state.users.visits;

/**
 * Closing an account has its own in-flight flag and its own error slot, kept
 * apart from `isLoading` and from the other slices' errors: a refused closure
 * must not blank the profile behind the dialog, and it must not light up an
 * error line on a page the operator is not looking at.
 */
export const isClosingAccountSelect = (state: AppRootStateType) =>
  state.users.isClosingAccount;
export const closeAccountErrorSelect = (state: AppRootStateType) =>
  state.users.closeAccountError;

/** The status dropdown's own in-flight flag and refusal, for the same reason. */
export const isSavingStatusSelect = (state: AppRootStateType) =>
  state.users.isSavingStatus;
export const statusErrorSelect = (state: AppRootStateType) =>
  state.users.statusError;
